module.exports = __webpack_public_path__ + "static/media/search.44d7d125.svg";